
export function _undefined<T> (): T {
  return undefined as unknown as T
}